export class VatSettingsModel {
  public vatSettingHashId: string;
  public description: string;
  public vat: string;
  public vatStartDate: string;
  public vatEndDate: string;
}
export class VatDefaultModel {
  public vatSettingDefaultCost: boolean = false;
  public defaultVatPenaltyCost: string = "";
  public defaultVatPeriodRates: string = "";
  public defaultVatTimeRates: string = "";
  public defaultVatDistanceRates: string = "";
  public defaultVatFixedRates: string = "";
  public defaultVatSubscriptionCost: string = "";
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vat-setting/models/vat-settings.model.ts